import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import LmConditionalByEditModeBuilderUi from '@/components/lmFormBuilderUi/LmConditionalByEditModeBuilderUi'

export default {
  data () {
    return {
      component: {},
      idOptionsSameAsValidationSelected: ''
    }
  },
  components: {
    LmTextInput,
    LmNumberInput,
    LmSelect,
    LmCheckbox,
    LmConditionalBuilderUi,
    LmConditionalByEditModeBuilderUi
  },
  props: {
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    optionsSameAsValidation: {
      type: Object,
      default: () => ({})
    },
    componentData: {
      type: Object,
      default: () => ({})
    },
    validationsData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number]
    },
    index: {
      type: Number
    },
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    validateSuperUser () {
      return this.$store.getters['session/userRole'] === 'Superusuario'
    }
  },
  methods: {
    initializeComponent () {
      this.validations = this.validationsData
      this.component = this.componentData
    },
    onInputValidationSameAs (optionsSameAsValidationSelected) {
      this.$emit('validations-changes', { [this.component.formObjectToSendToServerProperty]: this.validations })
      this.idOptionsSameAsValidationSelected = optionsSameAsValidationSelected?.id
      this.component.componentProps.labelOfFieldUsedForsameAsValidation = optionsSameAsValidationSelected?.label
      this.$emit('input', this.component)
    },
    nameFormatter (name) {
      return name.toLowerCase()
        .trim()
        .replaceAll(' ', '_')
        .replaceAll('á', 'a')
        .replaceAll('é', 'e')
        .replaceAll('í', 'i')
        .replaceAll('ó', 'o')
        .replaceAll('ú', 'u')
        .replaceAll('ñ', 'n')
        .replace(/\W+/g, '')
    },
    onLabelChange (event) {
      this.component.formObjectToSendToServerProperty = this.nameFormatter(event) + `_${this.getRandomName()}`
      this.$emit('input', this.component)
    },
    getRandomName (min = 0, max = 1000) {
      // Usamos Math.floor() para asegurarnos de que el resultado sea un entero dentro del rango.
      return `${Date.now()}_${Math.floor(Math.random() * (max - min)) + min}`
    }
  },
  watch: {
    validationsData () {
      // Esta linea causa errores, la comento para probar
      // Reestablecer el checked de "email" al cambiar el name
      // this.validations = this.validationsData
    },
    optionsSameAsValidation (newOne) {
      const optionSelected = newOne?.content?.find(e => e?.id === this.idOptionsSameAsValidationSelected)
      this.component.componentProps.labelOfFieldUsedForsameAsValidation = optionSelected?.label
      this.validations.sameAs = newOne?.content?.find(e => e?.id === this.idOptionsSameAsValidationSelected)?.value
      this.$emit('input', this.component)
    }
  },
  created () {
    this.initializeComponent()
  },
  mounted () {
    // eslint-disable-next-line no-unused-expressions
    // Se comenta el 22/8/2023:
    // Generaba un scroll muy molesto en los builders de documentos, tramites y personas
    // this.$refs?.inputFocus?.$refs?.lmTextInput?.focus()
  }
}
